<template>
  <div class="row brands">
    <div class="w-full px-4">
      <HeaderBreadcrumbs :items="[
        { label: 'Brands' },
      ]" title="All Brands" />

      <div class="bg-white p-0 my-3 rounded-lg shadow-sm">
        <div class="flex justify-between items-center px-4 pt-3  align-middle mb-3">
          <div class="block relative">
            <svg class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
            </svg>
            <input class="bg-white rounded-lg py-2 px-11 border w-96" placeholder='Search Brands Name, Code'
              v-model="query_search" @input="onSearch" />
            <button v-if="this.query_search?.length"
              class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
              @click="refreshPage" title="Clear search">
              ✕
            </button>

          </div>
          <button
            class="text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
            type="button">
            <router-link class="text-white px-1 py-2" :to="CreateBrandPath">
              <i class="fa fa-plus"></i> Add New
            </router-link>
          </button>
        </div>

        <div class="w-full">
          <Table 
          :headers="headers" 
          :data="brands" 
           :withScrollX="true"
          :isLoading="isLoading" 
          :withAction="false"
          :row-key="['name', 'brand_code', 'vendor_name','is_active', 'action_edit_brands', 'action_edit_premiums']"
          :current-page="currentPage" :per-page="20">
          <template #name="{ value }">
          <div class="px-0 py-1 rounded-lg w-96 text-left capitalize" :class="statusColor(value)">
           {{ value }}
          </div>
        </template>
            <template #is_active="{ value }">
          <div class="px-0 w-16 py-1 rounded-lg text-xs text-center  capitalize" :class="statusColor(value)">
            <p v-if="value" class="mb-0 px-0">
              Active
            </p>
            <p v-else class="mb-0 px-0">
              Inactive
            </p>
          </div>
        </template>
        <template #action_edit_brands="{ row }">
          <router-link :to="{ path: '/brands/editBrands/' + row.id }"
            class="link text-gray-600 align-middle items-center flex justify-center mr-4">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>

          </router-link>
        </template>
        <template #action_edit_premiums="{ row }">
          <router-link :to="{ path: '/brands/displayPremiums/' + row.id }"
            class="link text-gray-600 align-middle items-center flex justify-center mr-5">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>

          </router-link>
        </template>
          </Table>
        </div>

        <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 items-center mt-3 px-3">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              class="rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CreateBrandPath } from '../../router/clients';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Table from '@/components/form/table.vue'

export default {
  name: "Brand",
  components: {
    HeaderBreadcrumbs,
    Table,
  },
  data() {
    return {
      CreateBrandPath,
      currentPage: 1,
      perPage: 20,
      typing: false,
      debounceTimeout: null,
      query_search: '',
      filter: {},
      isLoadingSearch: false,
      items_search: [],
      debounce: null,
      fields: [
        { key: 'No', label: 'No' },
        { key: 'name', label: 'Name' },
        { key: 'brand_code', label: 'Code' },
        { key: 'vendor_name', label: 'Vendor' },
        { key: 'is_active', label: 'Status' },
        { key: 'action_edit_brands', label: 'Edit Brand' },
        { key: 'action_edit_category', label: 'Edit Category' },
        { key: 'action_edit_premiums', label: 'Edit Premium Offers' },
      ],
      headers: [
        { label: 'No', key: 'no' },
        { label: 'Brands name', key: 'name' },
        { label: 'Code', key: 'brand_code' },
        { label: 'Vendor', key: 'vendor_name' },
        { label: 'Status', key: 'is_active' },
        { label: 'edit brand', key: 'action_edit_brands'},
        { label: 'edit premium offers',key: 'action_edit_premiums' },

      ]
    };
  },
  watch: {
    currentPage: function () {
      this.actionGetBrand();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Brands | Content Management System Ebooks Gramedia.com';
      }
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.brands.isLoading,
      isError: (state) => state.brands.isError,
      totalRows: (state) => state.brands.totalRows,
      brands: (state) => state.brands.items,
    }),
  },
  mounted() {
    this.actionGetBrand();
  },
  methods: {
    ...mapActions("brands", ["fetchBrands", "searchBrands"]),
    actionGetBrand() {
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
      };
      if (this.query_search) {
        this.typing = true;
        payload.name = this.query_search;
        this.currentPage = 1
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          this.searchBrands(payload).then((response) => {
            this.items_search = response.data.data.rows;
            this.typing = false;
          }).catch(() => {
          });
        }, 600);

      } else {
        this.fetchBrands(payload);
      }
    },
    onClickPage(page) {
      this.currentPage = page;
      this.actionGetBrand();
    },
    statusColor(status) {
      switch (status) {
        case true:
          return 'bg-blue-100 px-1 text-blue-700';
        case false:
          return 'bg-gray-200 px-1 text-gray-800';
      }
    },
    onSearch() {
      this.actionGetBrand();
    },
    refreshPage() {
      this.query_search = null;
      this.currentPage = 1;
      this.actionGetBrand();
    },
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return '0';
    },
  },
};
</script>
<style scoped>
.h-custom {
  min-height: 800px;
}
</style>
